
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacyPolicy",
      function () {
        return require("private-next-pages/privacyPolicy/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/privacyPolicy"])
      });
    }
  